<template>
  <div>
    <v-app-bar color="#084cad" class="app-bar-safe">
      <!-- Botón regresar -->
      <v-btn icon variant="text" @click="$router.back()" class="text-white">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <!-- Logo -->
      <v-img
        src="https://mvexpress.mx/images/logosapp/logomv1.png"
        alt="Logo MV"
        max-width="200"
        contain
        class="mx-auto"
      />

      <!-- Notificaciones -->
      <div
        class="d-flex align-center"
        style="margin-left: auto; margin-right: 10px; position: relative"
      >
        <v-btn
          icon
          variant="text"
          class="text-white"
          @click="activarNotificaciones"
          :disabled="store.activas"
        >
          <v-icon size="28">
            {{ store.activas ? "mdi-bell-ring" : "mdi-bell-outline" }}
          </v-icon>
        </v-btn>

        <div
          v-if="store.nueva"
          style="
            position: absolute;
            top: 8px;
            right: 8px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: red;
          "
        ></div>
      </div>

      <!-- Botón de llamada -->
      <v-btn
        icon
        variant="text"
        class="text-white"
        @click="llamarTelefono('+529611416440')"
      >
        <v-icon size="28">mdi-phone</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main class="pa-0">
      <router-view />
    </v-main>
  </div>
</template>

<style>
/* Safe area top para app bar */
.app-bar-safe {
  padding-top: env(safe-area-inset-top, 25px); /* fallback 25px */
}

/* Safe area bottom para main (opcional) */
v-main {
  padding-bottom: env(safe-area-inset-bottom, 25px);
}
</style>


<script setup>
import { onMounted } from "vue";
import { PushNotifications } from "@capacitor/push-notifications";
import { Capacitor } from "@capacitor/core";
import { requestWebPushPermission } from "../../../firebase";
import Swal from "sweetalert2";
import { useNotificacionesStore } from "../../stores/notificacioneStore";

const store = useNotificacionesStore();
const llamarTelefono = (numero) => {
  // Abre la app de teléfono nativa si es móvil
  if (Capacitor.isNativePlatform()) {
    // En móviles nativos con Capacitor
    window.open(`tel:${numero}`, "_system");
  } else {
    // En web (desktop o navegador móvil)
    window.location.href = `tel:${numero}`;
  }
};
onMounted(async () => {
  if (Capacitor.isNativePlatform()) {
    const perm = await PushNotifications.requestPermissions();
    if (perm.receive === "granted") {
      await PushNotifications.register();
      store.activar();
    }

    PushNotifications.addListener("registration", (token) => {
      console.log("Token FCM móvil:", token.value);
    });
    PushNotifications.addListener("pushNotificationActionPerformed", (notification) => {
      console.log("📩 Notificación clickeada:", notification);
      const deepLink = notification.notification.data?.deep_link;
      if (deepLink) {
        // Aquí navegas dentro de tu app
        // Por ejemplo:
        window.location.href = deepLink;
      }
    });
    PushNotifications.addListener("pushNotificationReceived", (notification) => {
      console.log("📩 Notificación móvil recibida:", notification);
      store.marcarComoNueva();

      Swal.fire({
        icon: "info",
        title: notification.title || "Nueva notificación",
        text: notification.body || "Tienes un nuevo mensaje.",
        toast: true,
        timer: 3000,
        position: "top-end",
        showConfirmButton: false,
      });
    });
  }
  if (Capacitor.isNativePlatform()) {
    // Pedir permisos
    const perm = await PushNotifications.requestPermissions();
    if (perm.receive === "granted") {
      await PushNotifications.register();
      store.activar();
    }

    // Token FCM
    PushNotifications.addListener("registration", (token) => {
      console.log("Token FCM móvil:", token.value);
    });

    // App abierta
    PushNotifications.addListener("pushNotificationReceived", (notification) => {
      console.log("📩 Foreground:", notification);
      store.marcarComoNueva();
      // Mostrar alerta nativa o Swal
    });

    // App en background o cerrada -> al tocar notificación
    PushNotifications.addListener("pushNotificationActionPerformed", (notification) => {
      console.log("📩 Background/quit:", notification);
      // Aquí puedes navegar a una pantalla específica
      // ejemplo: router.push('/pedidos')
    });
  }
});

const activarNotificaciones = async () => {
  try {
    const token = await requestWebPushPermission();
    store.activar(token);

    Swal.fire({
      icon: "success",
      title: "¡Notificaciones activadas!",
      text: "Ahora recibirás avisos y recordatorios.",
      toast: true,
      timer: 2500,
      position: "top-end",
      showConfirmButton: false,
    });
  } catch (err) {
    console.error("Error al activar notificaciones:", err);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudieron activar las notificaciones.",
    });
  }
};
</script>
